import { render, staticRenderFns } from "./TitleCard.vue?vue&type=template&id=2ca58090&"
import script from "./TitleCard.vue?vue&type=script&lang=js&"
export * from "./TitleCard.vue?vue&type=script&lang=js&"
import style0 from "./TitleCard.vue?vue&type=style&index=0&id=2ca58090&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/administrator/staffpanel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ca58090')) {
      api.createRecord('2ca58090', component.options)
    } else {
      api.reload('2ca58090', component.options)
    }
    module.hot.accept("./TitleCard.vue?vue&type=template&id=2ca58090&", function () {
      api.rerender('2ca58090', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/material/TitleCard.vue"
export default component.exports